import React, { createContext, useEffect, useMemo, useState } from 'react';
import { Provider } from 'react-redux'
import LayoutComponent from './Components/Layout/LayoutComponent.js';
import {
  BrowserRouter as Router
} from "react-router-dom";
import { ConfigProvider, theme } from 'antd';
import ua from 'antd/locale/uk_UA.js';
import store from './store'
import './App.css';

export const ThemeModeContext = createContext({
  themeMode: 'light',
  setThemeMode: () => {},
});

function App() {
  const [themeMode, setThemeMode] = useState(() => localStorage.getItem('themeMode') || 'light');

  useEffect(() => {
    localStorage.setItem('themeMode', themeMode);
    document.body.setAttribute('data-theme', themeMode);
  }, [themeMode]);

  const themeContextValue = useMemo(() => ({
    themeMode,
    setThemeMode,
  }), [themeMode]);

  return (
    <Provider store={store}>
      <ThemeModeContext.Provider value={themeContextValue}>
        <Router>
          <ConfigProvider
          componentSize={'large'}
          locale={ua}
            theme={{
              algorithm: themeMode === 'dark' ? theme.darkAlgorithm : theme.defaultAlgorithm,
              token: {
                borderRadius: 10,
                colorPrimary: '#0f766e',
              },
            }}>
            <LayoutComponent />
          </ConfigProvider>
        </Router>
      </ThemeModeContext.Provider>
    </Provider>
  );
}

export default App;
